import axios from "axios";
export default class Header {
    constructor() {
        console.log('%c👍🏼 Header', 'color: yellow');
        this.dropdowns = document.querySelectorAll('.dropdown-toggle')  
        this.dropdownsToo = document.querySelectorAll('.dropdown-item--secondary')  
        
    }
    init() {
        this.dropdowns.forEach((elem) => {

            //aria-expand-true on desktop 

            elem.addEventListener('click', function (e) {
                if (window.matchMedia("(max-width: 992px)").matches) {
                    
                    let el = this.nextElementSibling;
                    el.style.display = el.style.display==='block'?'none':'block'
                }
            })
        })

        this.dropdownsToo.forEach((elem) => {

            //aria-expand-true on desktop 

            elem.addEventListener('click', function (e) {
                if (window.matchMedia("(max-width: 992px)").matches) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    let el = this.closest('.dropdown');
                    let toggle = el.querySelector('.dropdown-toggle');
                    console.log('.dropdown-toggle', toggle)
                    toggle.classList.add('show');
                }
            })
        })

        
        let jobsPills = document.querySelectorAll('.careers-number')  
        // Get the value of the hidden input field with ID 'movianto_home_url'
        var homeUrlValue = document.getElementById('movianto_home_url').value;
        let  apiString = homeUrlValue+'/wp-json/movianto/v2/careers'

        axios.get(apiString, {
            params: {
                status : 'publish'
            }
        })
        .then( (res) => {
            jobsPills.forEach((elem) => {
                elem.innerHTML = res.data.numPosts
                elem.classList.add('show');
            })
        })
    }
}